import { SEO } from '@/lib/seo'
import {
  Hero,
  PartnerLogos,
  Services,
  Industries,
  Process,
  WhyChooseUs,
  Testimonials,
  CTASection,
} from '@/components/sections'

export function Home() {
  return (
    <>
      <SEO />
      <Hero />
      <PartnerLogos />
      <Services />
      <Industries />
      <Process />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
    </>
  )
}

